import { settings } from '../../../settings/settings-util';
import {SessionRequestProcessor} from './request-processor-session';
import {Reducer} from "redux";
import {AlmeState} from "../../../wireup/AlmeState";
import reducer from "./reducers";

export default class SessionManager
{
    _settings: typeof settings;
    _reqProc: SessionRequestProcessor;

    constructor(passedSettings?: typeof settings)
    {
        this._settings = passedSettings ?? settings;
        this._reqProc = new SessionRequestProcessor(this._settings);
    }

    static getDefaultSettings(): typeof settings
    {
        return settings;
    }

    getReducer(): Reducer<AlmeState["Conversation"]>
    {
        return reducer;
    }

    getRequestProcessor(): SessionRequestProcessor
    {
        return this._reqProc;
    }
}


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/session/src/session.ts